import { zIndexLayersControl } from 'app/spacing';

export const CUSTOM_NAVIGATION_Z_INDEX = zIndexLayersControl(100, -1);
